import React from 'react'
import ColonialStandardPattern from './ColonialStandardPattern'
import ColonialContourPattern from './ColonialContourPattern'
import QueenAnnePattern from './QueenAnnePattern'
import ObscurityPattern from './ObscurityPattern'
import BlindsPattern from './BlindsPattern'

export const getGridPatternComponent = (gridStyleName) => {
  if (!gridStyleName) return null

  const name = gridStyleName.toLowerCase()

  if (name.includes('colonial standard')) {
    return ColonialStandardPattern
  } else if (name.includes('colonial contour')) {
    return ColonialContourPattern
  } else if (name.includes('queen anne')) {
    return QueenAnnePattern
  }

  return ColonialStandardPattern
}

const WindowPattern = ({ mode, isSelected, gridStyleName }) => {
  if (!isSelected) return null

  if (mode === 'grid') {
    const GridPattern = getGridPatternComponent(gridStyleName)
    return GridPattern ? <GridPattern /> : null
  } else if (mode === 'obscurity') {
    return <ObscurityPattern />
  } else if (mode === 'blinds') {
    return <BlindsPattern />
  }

  return null
}

export default WindowPattern
